"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1({ settlementRequestType, settlementRequestData, }) {
    const isPaymentRequest = settlementRequestType === 'payment';
    const isWithdrawRequest = settlementRequestType === 'withdraw';
    const { room_type_cd_id, room_status_cd_id, entered_waybill_count, commission_status } = settlementRequestData;
    const isLimitedSales = room_type_cd_id === 'ROOM_TYPE_00';
    const isPaymentSettlementable = room_status_cd_id === 'ROOM_STATUS_02';
    const isWithdrawSettlementable = room_status_cd_id === 'ROOM_STATUS_05' ||
        room_status_cd_id === 'ROOM_STATUS_06' ||
        entered_waybill_count > 0;
    const isCommissionSettlementable = commission_status === 5;
    const isSettlementDisabled = isPaymentRequest
        ? !isLimitedSales || !isPaymentSettlementable
        : isWithdrawRequest
            ? !isWithdrawSettlementable
            : !isCommissionSettlementable;
    return isSettlementDisabled;
}
exports.default = default_1;
